<template>
  <div id="login-page">
    <v-card
      class="mx-auto my-8"
      max-width="400"
      outlined
    >
      <v-card-title class="text-h4 ml-2 pb-2">
        Login
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-row>
            <v-col
              cols="12"
            >
              <v-text-field
                v-model="inputs.username"
                label="Username"
                required
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col
              cols="12"
            >
              <v-text-field
                v-model="inputs.password"
                label="Password"
                type="password"
                required
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-btn
          class="mb-2 mt-1 login-btn"
          color="primary"
          @click="login(inputs)"
          large
          block
        >
          Submit
        </v-btn>
      </v-card-actions>

      <div v-if="error" class="login-error">
        Failed to login: incorrect login or password
      </div>

    </v-card>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      inputs: {
        username: '',
        password: '',
      },
    };
  },
  computed: {
    ...mapState('auth', [
      'authenticating',
      'error'
    ]),
  },
  methods: {
    login({ username, password }) {
      localStorage.setItem('username', username);
      this.$store.dispatch('auth/login', { username, password })
      .then(() => this.$store.dispatch('auth/getRole', { }) .then( () =>  this.$router.push('/')));
    },
  },
};
</script>

<style>


#login-page::before {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  /*background-color: #edf8ff;*/
  content: "";
}


form input {
  display: block
}

/*
#login-elem {
  margin: 0 auto;
  margin-top: 300px;
  backgroud-color: #BFBEBD;
  border-width: 2px;
  border-style: solid;
  border-radius: 7px;
  max-width: 300px;
  padding: 15px 70px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
}

#login-elem h1 {
  text-align: center;
  font-size: 16pt;
  margin-bottom: 20px;
}

#login-elem input {
  border: none;
  padding: 5px 7px;
  width: 100%;
}

#login-elem input:not(:last-child) {
  margin-bottom: 12px;
}

#login-elem form {
  margin-bottom: 20px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
}

#login-button {
  margin: 0 auto;
  background-color: rgb(29, 78, 216);
  color: #fff;
  padding: 7px 45px;
  border: none;
  border-radius: 7px;
}

*/

/* because side navigation isn't shown */
/*
#app {
  padding-left: 0;
}
*/

.login-error {
  margin-top: 15px;
  margin-bottom: 15px;
  color: #e01103;
  text-align: center;
}

.login-btn .v-btn__content {
  font-weight: 800;
}

</style>



// WEBPACK FOOTER //
// src/views/Login.vue